import { Component, OnInit } from "@angular/core";

@Component({
  selector: "app-referal",
  templateUrl: "./referal.component.html",
  styleUrls: ["./referal.component.scss"],
})
export class ReferalComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
